import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clienthad() {
  return (
    <section
      className="client_had p-100 text_onsite"
      style={{ background: "#F8FCFF" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Solutions <span>Delivered</span>
            </h2>
            <p>
              To meet the project's goals and requirements, TekRevol delivered a
              comprehensive solution for both iOS and Android platforms to
              ensure a wide user reach.
            </p>
            <p>
              We have seamlessly integrated advanced location-based tracking
              within a 300-foot radius, facilitating effortless discovery of
              nearby individuals. It has been proven a pivotal aspect of the
              app's functionality for real-time connections.
            </p>
            <p>
              Meanwhile, the user authentication and profile management were
              streamlined with a seamless sign-up and sign-in process,
              simplifying user onboarding. The users could also conveniently
              link their social media accounts for quick access. Preferences
              could be tailored, aiding the app in suggesting relevant
              connections. Furthermore, users had the option to enrich their
              profiles by connecting NFTs and fostering unique and personalized
              interactions.
            </p>
            <p>
              Profile visibility could be enhanced through boosting, and
              initiating connections was made simple with the ability to send
              winks and engage in real-time chats. The app's auto-location
              tracking ensured precise positioning, while a subscription model
              introduced premium features to enhance the user experience.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img_onsite">
              <StaticImage
                src="../../../images/case-studies/onsite/delivered.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={789}
                height={613}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clienthad;
